import axios from '@/libs/api.request';

export const getOrderQuantityAnalyze = data => {
    return axios.request({
        url: 'api/statAnalyze/customerAnalyze/getOrderQuanityAnalyze',
        data: data,
        method: 'post'
    });
};

export const getOrderCountAnalyze = data => {
    return axios.request({
        url: 'api/statAnalyze/customerAnalyze/getOrderCountAnalyze',
        data: data,
        method: 'post'
    });
};

export const customerLoginStat = data => {
    return axios.request({
        url: 'api/statAnalyze/customerAnalyze/customerLoginStat',
        data: data,
        method: 'post'
    });
};

export const getOrderPriceAnalyze = data => {
    return axios.request({
        url: 'api/statAnalyze/customerAnalyze/getOrderPriceAnalyze',
        data: data,
        method: 'post'
    });
};

export const getCustomerCountAnalyze = data => {
    return axios.request({
        url: 'api/statAnalyze/customerAnalyze/getCustomerCountAnalyze',
        data: data,
        method: 'post'
    });
};

export const getCustomerQuantityAnalyze = data => {
    return axios.request({
        url: 'api/statAnalyze/customerAnalyze/getCustomerQuantityAnalyze',
        data: data,
        method: 'post'
    });
};
export const getTransactionAllocationList = data => {
    return axios.request({
        url: 'api/saleManagement/saleStat/getTransactionAllocationList',
        data: data,
        method: 'post'
    });
};